import request from '@/utils/request'

export default {
  /** 取消收藏 */
  closeCollect(data) {
    return request({
      method: 'post',
      url: '/integration/delCollectionCentre',
      data
    })
  },
  /** 添加收藏 */
  addCollect(data) {
    return request({
      method: 'post',
      url: '/integration/saveCollectionCentre',
      data
    })
  },
  queryCollectList(data) {
    return request({
      method: 'post',
      url: '/integration/collect/getAll',
      data
    })
  }
}